import { httpRequest } from '@calendly/http-tools'

export const getMemberships = (query = {}) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: { filter_term: query }
})

export const transferOwnership = (params) => httpRequest({
  url: '/api/organization/ownership',
  method: 'PUT',
  data: {
    user_id: params.newOwnerId,
    delete_account: params.deleteAccount,
    leave_organization: params.leaveOrganization,
    reason: params.reason,
    message: params.message,
    verification_code: params.verification_code
  }
})

export const accountUpdateRequest = (data) => httpRequest({
  url: '/api/account/settings',
  method: 'PATCH',
  data
})

export const submitUnlinkRequestCall = () => httpRequest({
  url: '/api/account/unlink_request',
  method: 'POST'
})

export const submitUnlinkVerificationCodeCall = (code) => httpRequest({
  url: '/api/account/unlink_request',
  method: 'GET',
  params: {
    code
  }
})

export const submitCredentialsUpdate = (data) => httpRequest({
  url: '/api/account/credentials',
  method: 'PUT',
  data
})

export const handleSmsLegalDisclaimer = (disclaimer = null) => {
  const reqData = {
    url: '/api/organization/sms_legal_disclaimer',
    method: disclaimer ? 'PUT' : 'DELETE',
    data: disclaimer ? { disclaimer } : undefined
  }

  return httpRequest(reqData)
}

export const getUserSettings = () => httpRequest({
  url: '/api/meetings/user_settings',
  method: 'GET'
})

export const patchUserSettings = (data) => httpRequest({
  url: '/api/meetings/user_settings',
  method: 'PATCH',
  data
})
